import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-Cors',
    templateUrl: './Cors.component.html'
})
export class CorsComponent implements OnInit {

    consumerID: string;
    origins: [];
    headers: [];
    exposed_headers: [];
    methods: [];
    max_Age: number;
    credentials = false;
    preflight_Continue = false;

    data = {
        'consumerID' : this.consumerID,
        'origins' : this.origins,
        'headers' : this.headers,
        'methods' : this.methods,
        'max_age' : this.max_Age,
        'credentials' : this.credentials,
        'exposed_headers' : this.exposed_headers,
        'preflight_continue' : this.preflight_Continue,
        'plugin' : 'cors'
    };

    constructor() { }
    slider() {
        this.credentials = !this.credentials;
    }
    slider1() {
        this.preflight_Continue = !this.preflight_Continue;
    }
    Cors() {
    }

    ngOnInit() {
    }

}
